<button
  type="button"
  (click)="onButtonClick()"
  class="btn btn-secondary btn-icon"
  [class.has-notification]="notificationCount() > 0"
  [attr.data-notification-count]="notificationCount() > 0 ? displayCount() : null"
  [attr.title]="title()"
  [attr.aria-label]="title()"
  [disabled]="disabled()"
  [attr.data-automation-id]="dataAutomationId"
>
  <i class="f-i f-i-xxl" [ngClass]="icon()"></i>
</button>
